"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadImg;

function loadImg(dataUrl, dims) {
  // destructure props from dims
  var minWidth = dims.minWidth,
      maxWidth = dims.maxWidth,
      minHeight = dims.minHeight,
      maxHeight = dims.maxHeight;
  return new Promise(function (resolve, reject) {
    // create a new html image element
    var img = new Image(); // set the image src attribute to our dataUrl

    img.src = dataUrl; // listen for onload event

    img.onload = function () {
      // validate the min and max image dimensions
      if (img.width < minWidth || img.height < minHeight) {
        reject(new Error("The uploaded image is too small. Must be at least ".concat(minWidth, "px by ").concat(minHeight, "px.")));
      }

      if (img.width > maxWidth || img.height > maxHeight) {
        reject(new Error("The uploaded image is too large. Must be no more than ".concat(maxWidth, "px by ").concat(maxHeight, "px.")));
      }

      resolve(true);
    };

    img.onerror = function () {
      return reject(new Error('There was an error uploading the image'));
    };
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/ImagePicker/load-image.js
// module id = ./node_modules/quark-web/components/form/ImagePicker/load-image.js
// module chunks = 0